export default __webpack_public_path__ + "assets/images/3b5f29660af2326c8ad2d82ba77ed4d4.png";